/**
 * Enables search to work in the select search control
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/manipulation/empty/empty.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/dimensions/scroll/scroll.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/attributes/prop/prop.js";

export default (obj, cls) => {
	obj.each(function () {
		let $this = $(this),
			input = $(cls+"-search-input", $this),
			value = $(cls + "-value", $this),
			href = input.data("callback"),
			timer;

		// fetch the results, optionally resetting the selection as it may not be in the filtered dataset
		const search = reset => {
			const loading = cls + "-search-input--loading";
			input.addClass(loading);
			fetch(href + "&ss=" + encodeURIComponent(input.val()) + "&ssg=" + encodeURIComponent($this.data("group") || ""), {headers: {accept: "text/html"}})
				.then(response => response.text())
				.then(html => {
					const results = $(cls+"-results", $this).empty().append(html).scrollTop(0);
					input.removeClass(loading);

					// the empty item heads up the results, so the label can be reset from it
					if (reset) {
						const item = $("li[data-id='']", results);
						value.val("").trigger("change");
						if (item.length) {
							$(cls + "-label", $this).text(item.text().trim());
						}
					}
				});
		};

		// re-run the search when this control is filtered by another
		$this.on("filtered", (e, reset) => search(reset));

		// get search suggestions
		input.on("keyup", e => {
			const val = input.val();

			if (val !== $this.data("last-value")) {
				input.addClass(cls + "-search-input--loading");
				window.clearTimeout(timer);
				timer = window.setTimeout(search, e.key === "Enter" ? 1 : 500);
			}
			$this.data("last-value", val);

		// cancel enter button submitting form on search box
		}).on("keypress", (e) => {
			if (e.key === "Enter") {
				return false;
			}
		});

		// select an item, the label and switch are updated before the change event so listeners see the new selection
		$this.on("click", "li[data-id]", function () {
			const self = $(this);
			$(cls + "-label", $this).text(self.text());
			$(cls + "-switch", $this).prop("checked", "");
			value.val(self.data("id")).trigger("change");
		});
	});
};
